import { WATCHLIST_MEMBERS_RETRIEVE_REQUEST, WATCHLIST_MEMBERS_RETRIEVED, WATCHLIST_MEMBERS_RETRIEVE_ERR, WATCHLIST_MEMBER_CREATE_REQUEST, WATCHLIST_MEMBER_CREATED, WATCHLIST_MEMBER_CREATE_ERR, WATCHLIST_MEMBER_DELETE_REQUEST, WATCHLIST_MEMBER_DELETED, WATCHLIST_MEMBER_DELETE_ERR, WATCHLIST_MEMBER_UPDATE_REQUEST, WATCHLIST_MEMBER_UPDATED, WATCHLIST_MEMBER_UPDATE_ERR } from '../actionTypes';
import * as watchlist from '../../api/zoomboard';
import errors from '../../config/errors';

export function getWatchlist() {
  return async dispatch => {
    dispatch({ type: WATCHLIST_MEMBERS_RETRIEVE_REQUEST });
    try {
      let result = await watchlist.getWatchlist();
      if (result.data.success) {
        dispatch({ type: WATCHLIST_MEMBERS_RETRIEVED, data: result.data.watchlist })
      } else {
        dispatch({ type: WATCHLIST_MEMBERS_RETRIEVE_ERR, error: errors.RequestFailed });
      }
    } catch(error) {
      dispatch({ type: WATCHLIST_MEMBERS_RETRIEVE_ERR, error: errors.RequestFailed });
    }
  }
}

export function createWatchlistMember(data) {
  return async dispatch => {
    dispatch({ type: WATCHLIST_MEMBER_CREATE_REQUEST });
    try {
      let result = await watchlist.createWatchlistMember(data);
      if (result.data.success) {
        dispatch({ type: WATCHLIST_MEMBER_CREATED, data: result.data.member });
        return true;
      } else {
        dispatch({ type: WATCHLIST_MEMBER_CREATE_ERR , error: errors.RequestFailed});
        return false;
      }
    } catch (error) {
      dispatch({ type: WATCHLIST_MEMBER_CREATE_ERR, error: errors.RequestFailed });
      return false;
    }
  }
}

export function deleteWatchlistMember(memberId) {
  const objectId = memberId;
  return async dispatch => {
    dispatch({ type: WATCHLIST_MEMBER_DELETE_REQUEST, objectId });
    try {
      let result = await watchlist.deleteWatchlistMember(objectId);
      if (result.data.success) {
        dispatch({ type: WATCHLIST_MEMBER_DELETED, objectId });
        return true;
      } else {
        dispatch({ type: WATCHLIST_MEMBER_DELETE_ERR, objectId, error: errors.RequestFailed });
        return false;
      }
    } catch (error) {
      dispatch({ type: WATCHLIST_MEMBER_DELETE_ERR, objectId, error: errors.RequestFailed });
      return false;
    }
  }
}

export function updateWatchlistMember(memberId, data) {
  const objectId = memberId;
  return async dispatch => {
    dispatch({ type: WATCHLIST_MEMBER_UPDATE_REQUEST, objectId });
    try {
      let result = await watchlist.updateWatchlistMember(objectId, data);
      if (result.data.success) {
        dispatch({ type: WATCHLIST_MEMBER_UPDATED, objectId, data: result.data.member });
        return true;
      } else {
        dispatch({ type: WATCHLIST_MEMBER_UPDATE_ERR, objectId, error: errors.RequestFailed });
        return false;
      }
    } catch (error) {
      dispatch({ type: WATCHLIST_MEMBER_UPDATE_ERR, objectId, error: errors.RequestFailed });
      return false;
    }
  }
}